import React from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";

export default function Portfolio() {
  const projects = [
    {
      title: "Auteuristic Systems",
      image: "/Old/images/ASHorizontalBackground.png",
      logo: "/Old/images/logos/ASLogo_transparent.png",
      link: "https://auteuristicsystems.com",
      description: "Click logo to visit Auteuristic Systems – Empowerment through technology.",
      showLogoOverlay: true,
    },
    {
      title: "Dione's Fashions Inventory",
      image: "/Old/images/diones.png",
      logo: "/Old/images/logos/DFLogo.png",
      link: "/Old/Diones/diones-inventory/index.html",
      description: "Click logo for KSU school project for Foundations DB and Web XLS SWE 5063 - Dione's Fashions Inventory",
    },
    {
      title: "Frogger Clone",
      image: "/Old/images/frogger.jpg",
      logo: "/Old/images/logos/froggerLogo2.png",
      link: "/Old/frogger/index.html",
      description: "Simplified Frogger in JS — click logo to play (keyboard required)",
    },
    {
      title: "GA Tech Diploma",
      image: "/Old/images/GATechDiploma.png",
      logo: "/Old/images/logos/GATechLogo.png",
      link: "/Old/GATechDiploma.pdf",
      description: "Click logo to access certified diploma and verification instructions",
    },
    {
      title: "CompTIA A+ Certificate",
      image: "/Old/images/comptia.png",
      logo: "/Old/images/logos/CompTIAlogo.png",
      link: "/Old/CompTIAAPlusCertificate.pdf",
      description: "Click logo to access a PDF of my A+ certification",
    },
    {
      title: "Graduate Certificate (KSU)",
      image: "/Old/images/GradCert.jpg",
      logo: "/Old/images/logos/ksulogo.png",
      link: "/Old/GradCert.pdf",
      description: "Click logo to access my graduate certificate from KSU",
    },
    {
      title: "UTC Diploma",
      image: "/Old/images/Portfolio1.png",
      logo: "/Old/images/logos/UTCLogo.png",
      link: "/Old/GaryPinkleyCertifiedDiploma.pdf",
      description: "Click logo to access certified diploma and verification instructions",
    },
    {
      title: "Georgia Tech",
      image: "/Old/images/GATech.png",
      logo: "/Old/images/logos/GATechLogo.png",
      link: "https://www.gatech.edu/",
      description: "Click logo to go to GATech website:  I completed my MSCS (spc. Interactive Intelligence) May 2025 with a 3.5 GPA",
    },
    {
      title: "UTC Website",
      image: "/Old/images/UTC.png",
      logo: "/Old/images/logos/UTCLogo.png",
      link: "https://www.utc.edu/",
      description: "Click logo to go to UTC website: MSCS coursework and teaching assistantship and BS Psychology completed here",
    },
    {
      title: "KSU Website",
      image: "/Old/images/KSU.png",
      logo: "/Old/images/logos/ksulogo.png",
      link: "https://www.kennesaw.edu/",
      description: "Click logo to go to KSU website: I earned a graduate certificate in software engineering from KSU May 2022",
    },
  ];

  return (
    <main className="bg-zinc-900 text-zinc-100 px-6 md:px-12 py-12 space-y-2 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6 max-w-4xl mx-auto text-center space-y-4">
          <Header />
        </div>
          <section className="text-center space-y-4">     
              <h1 className="mb-6 text-4xl font-bold">Project Portfolio</h1>
              <p>Explore my academic and personal work below.</p>
          </section>

        <section className="pt-8 grid grid-cols-1 sm:grid-cols-1 md:portrait:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto px-2">
    {projects.map
      ((project) => 
       (
          <div
            key={project.title}
            className="relative h-60 rounded-lg overflow-hidden shadow-lg group"
          >
            {/* Background Image as a CSS class */}
            <div
              className="absolute inset-0 bg-cover bg-top bg-no-repeat"
              style={{ backgroundImage: `url(${project.image})` }}
            ></div>

            {/* Static Logo (only visible before hover) */}
            {project.showLogoOverlay && (
              <img
                src={project.logo}
                alt={`${project.title} logo`}
                className="absolute inset-0 m-auto z-10 pointer-events-none group-hover:opacity-0 transition-opacity duration-300 w-auto max-h-44 object-contain"
              />
            )}

            {/* Hover Overlay */}
            <div className="absolute inset-0 z-20 bg-black bg-opacity-90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-between text-center px-4 py-4">
              <a href={project.link} target="_blank" rel="noopener noreferrer">
                <img
                  src={project.logo}
                  alt={`${project.title} logo`}
                  className={`w-auto object-contain transition-all duration-300 ${
                    project.title === "Auteuristic Systems" ? "max-h-44" : "max-h-28"
                  }`}
                />
              </a>
              <p className="text-sm text-zinc-200">{project.description}</p>
            </div>
          </div>

        )
      )
    }
        </section>
        <Footer />
      </div>  
    </main>
  );
}
